import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moduleCompany from "@/store/company/moduleCompany.js";
import OptimizerManager from "@/models/OptimizerManager";
import Datepicker from "vuejs-datepicker";
import {en, es} from "vuejs-datepicker/src/locale";
import {Validator} from "vee-validate";
import ManageErrorMessages from "@/models/ManageErrorMessages";
import DateUtils from "@/helpers/DateUtils.js";

export const optimizerManagerMixin = {
	name: "OptimizerManagerCreate",
	components: {
		vSelect,
		flatPickr,
		Datepicker,
	},
	props: {
		data: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			selectedOptimizationApi: null,
			selectedCompany: null,
			selectedService: {label: this.$t("Optimization.Optimization"), value: "optimization"},
			optimizerManager: new OptimizerManager({}),
			companyOptimizerServices: {},
			langHe: es,
			langEn: en,
			manageErrorMessages: new ManageErrorMessages({that: this}),
			dangerInput: {
				name: {show: false, text: ""},
				identification: {show: false, text: ""},
				apikey: {show: false, text: ""},
				city: {show: false, text: ""},
				country: {show: false, text: ""},
				phone: {show: false, text: ""},
				cy: {show: false, text: ""},
				cx: {show: false, text: ""},
			},
			configdateTimePicker: {
				enableSeconds: true,
				enableTime: true,
				noCalendar: true,
			},
			optimizerList: [
				{label: "OPENROUTE", value: "OPENROUTE"},
				{label: "GMPRO", value: "GMPRO"},
				{label: "TOUR PLANNING", value: "TOUR_PLANNING"},
				{label: "SERVIROUTES", value: "SERVIROUTES"},
			],
			serviceList: [
				{label: this.$t("Optimization.Optimization"), value: "optimization"},
				{label: this.$t("RoutingService"), value: "routing"},
				{label: this.$t("Matrix"), value: "matrix"},
				{label: this.$t("MapMatching"), value: "mapmatching"},
				{label: this.$t("Isochrones"), value: "isochrones"},
				{label: this.$t("Clustering.Title"), value: "clustering"},
			],
		};
	},
	computed: {
		isGotu() {
			const userInfo = JSON.parse(localStorage.getItem("userInfo"));
			return userInfo.serviroutes_role_name === "GOTU";
		},
		listCompanies() {
			return this.isGotu
				? this.$store.state.moduleCompany.companies
				: [this.$store.state.moduleCompany.companies];
		},
		disabledDatesTo() {
			return {to: new Date()};
		},
		validateForm() {
			return !this.errors.any();
		},
		filteredServiceList() {
			const api = this.selectedOptimizationApi ? this.selectedOptimizationApi.value : null;
			const existingServices = this.companyOptimizerServices[api] || [];
			let list;
			if (api === "SERVIROUTES") {
				list = this.serviceList.filter((s) => s.value === "clustering");
			} else if (api === "TOUR_PLANNING") {
				list = this.serviceList.filter((s) => s.value === "routing" || s.value === "optimization");
			} else if (api === "GMPRO") {
				list = this.serviceList.filter((s) => s.value === "optimization");
			} else {
				list = this.serviceList.filter((s) => s.value !== "clustering");
			}
			return list.filter((s) => !existingServices.includes(s.value));
		},
	},
	watch: {
		selectedOptimizationApi(newVal) {
			if (newVal && newVal.value === "SERVIROUTES") {
				this.selectedService = {label: this.$t("Clustering.Title"), value: "clustering"};
			} else {
				this.selectedService = {label: this.$t("Optimization.Optimization"), value: "optimization"};
			}
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		getCompany() {
			this.openLoading();
			this.$store
				.dispatch("moduleCompany/fetchDataListItems")
				.then((res) => {
					this.closeLoading();
				})
				.catch((err) => {
					this.closeLoading();
					console.error(err);
				});
		},
		validatorExpireDate(value, args) {
			if (!value || value === "" || typeof value === "number") {
				return true;
			}
			const expDate = typeof value === "string" ? new Date(value).getTime() : value.getTime();
			const optimizerDate =
				typeof this.optimizerManager.date_end === "string"
					? new Date(this.optimizerManager.date_end).getTime()
					: this.optimizerManager.date_end.getTime();
			return expDate <= optimizerDate;
		},
		save_changes() {
			if (!this.validateForm) return;
			this.$validator.validateAll().then((result) => {
				if (result) {
					if (!this.validateForm) return;
					this.registerOptimizerManager();
				} else {
					this.$vs.notify({
						color: "danger",
						title: this.$t("VisitPoints.ValidData.Title"),
						text: this.$t("VisitPoints.ValidData.Text"),
						time: 6000,
					});
					this.activeTab = 0;
				}
			});
		},
		registerOptimizerManager() {
			delete this.optimizerManager.id;
			this.optimizerManager["optimization_api"] = this.selectedOptimizationApi.value || "";
			const apiVal = this.selectedOptimizationApi.value;
			this.optimizerManager["service"] =
				(apiVal === "OPENROUTE" ||
					apiVal === "SERVIROUTES" ||
					apiVal === "TOUR_PLANNING" ||
					apiVal === "GMPRO") &&
				this.selectedService
					? this.selectedService.value
					: "optimization";
			this.optimizerManager["company_id"] = this.selectedCompany.id || "";
			this.optimizerManager["date_end"] = DateUtils.toDefaultDateTime(
				this.optimizerManager.date_end,
				"YYYY-MM-DD"
			);
			this.optimizerManager["points_per_month"] =
				this.optimizerManager.points_per_month >= 0 ? parseInt(this.optimizerManager.points_per_month) : null;
			this.optimizerManager["points_per_week"] =
				this.optimizerManager.points_per_week >= 0 ? parseInt(this.optimizerManager.points_per_week) : null;
			this.optimizerManager["points_per_day"] =
				this.optimizerManager.points_per_day >= 0 ? parseInt(this.optimizerManager.points_per_day) : null;
			this.optimizerManager["points_total"] =
				this.optimizerManager.points_total >= 0 ? parseInt(this.optimizerManager.points_total) : null;
			this.optimizerManager["points_subscription_monthly"] =
				this.optimizerManager.points_subscription_monthly >= 0
					? parseInt(this.optimizerManager.points_subscription_monthly)
					: null;
			this.$store
				.dispatch("optimizerManager/save", this.optimizerManager)
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("OptimizerManager.Success.Title"),
						text: this.$t("OptimizerManager.Success.Text"),
					});
					this.optimizerManager = new OptimizerManager({});
					this.$router.push({name: "app-optimizer-manager-list"});
				})
				.catch((error) => {
					this.manageErrorMessages.processErrorOptimizerManager(error.data[0]);
					console.error(error);
				});
		},
		validateAmountNumber(event) {
			let regex = /^\d+$/;
			let key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
			if (!regex.test(key)) {
				event.preventDefault();
				return false;
			}
		},
		removeOptimizerExist(val) {
			if (val.optimizers.length > 0) {
				for (let item in this.optimizerList) {
					for (let key in val.optimizers) {
						if (
							val.optimizers[key] != "OPENROUTE" &&
							val.optimizers[key] != "TOUR_PLANNING" &&
							val.optimizers[key] != "GMPRO" &&
							this.optimizerList[item].value === val.optimizers[key]
						) {
							this.optimizerList.splice(item, 1);
						}
					}
				}
				this.fetchCompanyOptimizerServices(val.id);
			} else {
				this.optimizerList = [
					{label: "OPENROUTE", value: "OPENROUTE"},
					{label: "GMPRO", value: "GMPRO"},
					{label: "TOUR PLANNING", value: "TOUR_PLANNING"},
					{label: "SERVIROUTES", value: "SERVIROUTES"},
				];
				this.companyOptimizerServices = {};
			}
		},
		fetchCompanyOptimizerServices(companyId) {
			this.$store
				.dispatch("optimizerManager/optimizerManagerFilter", {
					company_id: [companyId],
					match_filter: true,
					order_by: ["id"],
					sort: "desc",
					page: 1,
					quantity: 1000,
				})
				.then((res) => {
					const services = {};
					(res.records || []).forEach((record) => {
						const api = record.optimization_api;
						if (!services[api]) services[api] = [];
						if (record.service && !services[api].includes(record.service)) {
							services[api].push(record.service);
						}
					});
					this.companyOptimizerServices = services;
				})
				.catch((err) => {
					console.error(err);
				});
		},
	},
	created() {
		// modulo de empresa
		if (!moduleCompany.isRegistered) {
			this.$store.registerModule("moduleCompany", moduleCompany);
			moduleCompany.isRegistered = true;
		}
		Validator.extend("validatorExpireDate", this.validatorExpireDate);
		this.getCompany();
	},
	mounted() {
		this.showMap = true;
		if (this.$route.params.company_id) {
			const foundCompany = this.listCompanies.find((company) => company.id === this.$route.params.company_id);
			if (foundCompany)
				this.selectedCompany = this.listCompanies.find(
					(company) => company.id === this.$route.params.company_id
				);
			this.removeOptimizerExist(this.selectedCompany);
		}
	},
};
